import React, { Fragment } from "react";
import "../../style/custom/radio-addon.scss";
import {getFormData} from "../../components/manager/form";
import {
  getProductsQuery,
  getProductsResult,
} from "../../components/logic/products";
import {useQuery} from "@apollo/client";
import { NON_INTERNET_PRODUCT_TYPES_TO_SHOW } from "../../utils/constant";

export default function CheckAddOn(props) {

  const {
    title, 
    onRemoveProduct,
    onAddProduct,
    disableHardWare = false,
    addons = [], 
    buildingCode = "",
    voucherCode,
    readOnly,
  } = props;
  
  const data = getFormData();

  const result = useQuery(getProductsQuery, {
    variables: {
      buildingCode: data.buildingCode || buildingCode,
      voucherCode: voucherCode || data.voucherCode,
      showHidden: true,
      selectedProductIds: [],
    },
  });


  if (result.loading) {
    return <React.Fragment />;
  }

  const products = getProductsResult(result);
  if (products.length === 0) {
    return <div />;
  }

  const bindOnToggleClick = (product, active) => {
    if (readOnly) {
      return undefined;
    }
    return (e) => {
      if (active) {
        return onRemoveProduct(product);
      }

      const selectevents = product?.selectEventsActivate || [];
      let events = [];

      (selectevents || []).forEach((event) => {
        const eventProduct = products.find((p) => (p.name || "").toLowerCase() === (event || "").toLowerCase());
        if (eventProduct) {
          events.push(eventProduct);
        }
      });

      return onAddProduct(product, events);
    };
  };

  const genericAddons = products.filter((p) => NON_INTERNET_PRODUCT_TYPES_TO_SHOW.indexOf(p.type) > -1);
  const hardwareAddons = products.filter((p) => p.type === "hardware");

  const Checkbox = ({p, handleClick ,active}) => {
    return (
      <div className="checkbox-wrapper">
      <label className="checkbox-container">
        <input 
          type="checkbox" 
          checked={active}
          onChange={handleClick} 
        />
        <span className="check-label">
          {`${p.description} (+$${p.value}) ${
            !p.once ? "/Month" : " once off"
          }`}
        </span>
      </label>
      </div>
    )
  }

  return(
    <div className="addon-static-container">
      {genericAddons.length > 0 && (
        <Fragment>
          <p className="radio-addon-title">{title}</p>
          {genericAddons.map((p) => {
            const active = !!(addons.find((a) => a.id === p.id));
            const handleClick = bindOnToggleClick(p, active);
            return(
              <Checkbox
                key={p.id}
                p={p}
                active={active}
                handleClick={handleClick}
              />
            )
          })}
        </Fragment>
      )}

      {!disableHardWare && hardwareAddons.length > 0 ? (
        <Fragment>
          <p className="radio-addon-title">{"Optional Hardware"}</p>
          {hardwareAddons.map((p) => {
            const active = addons.find((a) => a.id === p.id);
            const handleClick = bindOnToggleClick(p, active);
            return(
              <Checkbox
                key={p.id}
                p={p}
                active={active}
                handleClick={handleClick}
              />
            );
          })}
        </Fragment>
      ) : undefined}
    </div>
  )
}